var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 163,
    viewBox: "0 0 236 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10138_5937)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 228,
    height: 155,
    fill: "#525050",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.1 54H89.9C88.07 54 86.315 54.6739 85.021 55.8735C83.727 57.073 83 58.7 83 60.3964V92.3783C83.0012 92.8081 83.1426 93.2276 83.4055 93.5817C83.6685 93.9358 84.0408 94.2079 84.4735 94.3624C84.9063 94.5169 85.3793 94.5465 85.8305 94.4473C86.2817 94.3482 86.6901 94.1249 87.002 93.8068L105.747 74.4471L118.627 91.696C118.805 91.9324 119.033 92.133 119.297 92.2854C119.561 92.4378 119.856 92.5391 120.163 92.5829C120.471 92.6268 120.785 92.6123 121.086 92.5405C121.387 92.4687 121.67 92.341 121.916 92.165L135.716 82.3786L148.09 94.0413C148.409 94.3313 148.811 94.529 149.249 94.6104C149.687 94.6917 150.141 94.6532 150.555 94.4995C150.97 94.3458 151.327 94.0835 151.584 93.7447C151.84 93.4059 151.985 93.0052 152 92.5915V60.3964C152 58.7 151.273 57.073 149.979 55.8735C148.685 54.6739 146.93 54 145.1 54Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.326 91.0998L137.526 78.0938C137.132 77.7245 136.607 77.5012 136.048 77.4659C135.489 77.4305 134.935 77.5856 134.49 77.9019L119.126 88.8397C118.661 89.1739 118.351 89.6608 118.261 90.2003C118.171 90.7398 118.308 91.2906 118.643 91.7394L124.807 99.9907C125.019 100.273 125.301 100.504 125.629 100.664C125.957 100.823 126.323 100.907 126.693 100.908H145.093C146.923 100.908 148.678 100.234 149.972 99.0341C151.266 97.8345 151.993 96.2076 151.993 94.5112V92.5922C151.991 92.0329 151.751 91.4969 151.326 91.0998Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.586 97.5605L107.886 69.8428C107.689 69.5765 107.429 69.3553 107.126 69.1958C106.823 69.0364 106.484 68.9428 106.137 68.9223C105.789 68.9017 105.44 68.9547 105.118 69.0773C104.795 69.1998 104.507 69.3887 104.275 69.6296L83.5751 90.9509C83.2 91.3451 82.9953 91.8538 83.0001 92.3794V94.5115C83.0001 96.2079 83.727 97.8349 85.021 99.0344C86.315 100.234 88.0701 100.908 89.9001 100.908H126.7C127.12 100.907 127.531 100.8 127.89 100.598C128.248 100.397 128.541 100.108 128.735 99.7628C128.929 99.4181 129.018 99.0306 128.992 98.6424C128.966 98.2542 128.825 97.88 128.586 97.5605Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.702 73.1848C129.242 73.1848 131.302 71.2756 131.302 68.9205C131.302 66.5654 129.242 64.6562 126.702 64.6562C124.161 64.6562 122.102 66.5654 122.102 68.9205C122.102 71.2756 124.161 73.1848 126.702 73.1848Z",
    fill: "#6F6F6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10138_5937",
    x: 0,
    y: 0,
    width: 236,
    height: 163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10138_5937"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10138_5937",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/noImage.c5f31df8150751f7907c99457ffe4f57.svg";
export { ForwardRef as ReactComponent };